
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Widget } from '@typeform/embed-react';
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Text from 'components/atomic/atoms/text';
import { useRouter } from 'next/router';
import { checkQuizResults, saveQuizResults } from 'utils/quiz';
import Button from 'components/atomic/atoms/button';
import MainLayout from 'components/layouts/main-layout';
const ButtonsWrapper = styled('div') `
    display: flex;
    column-gap: 1.5rem;
    justify-content: center;
    > button {
        min-width: 12rem;
    }
`;
const ContentWrapper = styled('div') `
    display: flex;
    flex-direction: column;
    row-gap: 1.5rem;
    padding-top: 3rem;
`;
const QuizPage = () => {
    const [quizId, setQuizId] = React.useState<string | null | undefined>(undefined);
    const formId = process.env.REACT_APP_TYPEFORM_ID;
    const router = useRouter();
    const handleFormSubmit = (value: string) => {
        if (value) {
            saveQuizResults(value).then(() => {
                router.push(`quiz-results/${value}`);
            });
        }
    };
    React.useEffect(() => {
        checkQuizResults().then((value) => {
            setQuizId(value);
        });
    }, []);
    if (quizId && quizId !== null) {
        return (<MainLayout title="Test di Orientamento">
                <ContentWrapper>
                    <Text textAlign="center" variant="h3">
                        Hai gia effettuato il quiz del Gesù
                    </Text>
                    <ButtonsWrapper>
                        <Button size="large" variant="contained" onClick={() => router.push(`quiz-results/${quizId}`)}>
                            Guarda i risultati
                        </Button>
                        <Button size="large" variant="outlined" onClick={() => setQuizId(null)}>
                            Fai il quiz
                        </Button>
                    </ButtonsWrapper>
                </ContentWrapper>
            </MainLayout>);
    }
    if (formId) {
        return (<Widget id={formId} style={{ width: '100%', height: '100vh' }} onSubmit={({ responseId }) => handleFormSubmit(responseId)} className="my-form"/>);
    }
};
export default QuizPage;

    async function __Next_Translate__getStaticProps__18916ceb1da__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/sorting-quiz',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18916ceb1da__ as getStaticProps }
  